import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const ItemsLoading: TOC<Signature> = <template>{{outlet}}</template>;

export default ItemsLoading;
